<template>
  <div v-if="modelValue?.open" class="iframe__body" @click.self="closeViewer">
    <button class="iframe__close" type="button" @click="closeViewer">
      <span class="material-icons">close</span>
    </button>

    <iframe
      v-if="isOfficePreview"
      width="100%"
      height="100%"
      :src="officePreviewUrl"
      frameborder="0"
      allowfullscreen
    />

    <div v-else class="iframe__image-wrap">
      <img class="iframe__img" :src="modelValue.url" alt="preview" />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({
      open: false,
      url: "",
      type: "",
    }),
  },
});

const emit = defineEmits(["update:modelValue"]);

const isOfficePreview = computed(() => {
  const type = String(props.modelValue?.type || "");
  return !type.startsWith("image/");
});

const officePreviewUrl = computed(() => {
  const src = encodeURI(String(props.modelValue?.url || ""));
  return `https://view.officeapps.live.com/op/embed.aspx?src=${src}&embedded=true`;
});

function closeViewer() {
  emit("update:modelValue", {
    open: false,
    url: "",
    type: "",
  });
}
</script>

<style scoped>
.iframe__img {
  width: 100%;
  max-width: 1200px;
  max-height: 100%;
  object-fit: contain;
  margin: 0 auto;
}

.iframe__body {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  cursor: default;
}

.iframe__image-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.iframe__close {
  position: fixed;
  right: 20px;
  top: 20px;
  color: #eb5757;
  z-index: 1060;
  background: none;
  border: none;
}
</style>
